import React, { Component } from "react";

export default class Impressum extends Component {
  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "instant" });
  }

  render() {
    return (
      <div className="section-container">
        <div className="container">
          <div className="padding-block-500">
            <div className="misc-heading">Impressum</div>
            <br />
            <div className="misc-paragraph">
              <h3 className="fw-bold">Angaben gemäß § 5 TMG:</h3>
              <p>Epikur GmbH</p>
              <p>Geschäftsführer: Uwe Schrader, Katja Dietrich</p>
              <p>Bahnhofstraße 4, 04895 Falkenberg/Elster</p>
              <p>Tel.: 035365-3828110</p>
              <p>info@epikur-gesundheit.de</p>
              <br />
              <p>Umsatzsteuer-ID: DE237713219</p>
              <br />
              <p>HRB 7155 CB</p>
              <p>Registergericht: Cottbus</p>
              <br />
              <span>
                <h3 className="fw-bold">
                  Angaben zur Berufshaftpflichtversicherung
                </h3>
                <p>(Für alle Praxen der Ergo- und Physiotherapie)</p>
              </span>
              <p>Berufe: Physio- und Ergotherapeuten</p>
              <p>Name und Sitz des Versicherers:</p>
              <p>Aachen Münchner</p>
              <p>Kundenservice-Direktion Hamburg</p>
              <p>20081 Hamburg</p>
              <p>Geltungsraum der Versicherung: Deutschland</p>
              <br />
              <h2 className="fw-bold">Streitschlichtung</h2>

              <p>
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{" "}
                <a href="https://ec.europa.eu/consumers/odr">
                  https://ec.europa.eu/consumers/odr
                </a>
                .
              </p>
              <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
              <p>
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
              <br />
              <h3 className="fw-bold">Haftung für Inhalte</h3>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                gespeicherte fremde Informationen zu überwachen oder nach
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                hinweisen.
              </p>
              <br />
              <p>
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
                Informationen nach den allgemeinen Gesetzen bleiben hiervon
                unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
                Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
                Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden
                wir diese Inhalte umgehend entfernen.
              </p>
              <br />
              <h3 className="fw-bold">Haftung für Links</h3>
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
                wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
                Verlinkung nicht erkennbar.
              </p>
              <br />
              <p>
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
                jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
                zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
                derartige Links umgehend entfernen.
              </p>
              <br />
              <h3 className="fw-bold">Urheberrecht</h3>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                diesen Seiten unterliegen dem deutschen Urheberrecht. Die
                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten,
                nicht kommerziellen Gebrauch gestattet.
              </p>
              <br />
              <p>
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
                wurden, werden die Urheberrechte Dritter beachtet. Insbesondere
                werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie
                trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
                bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden
                von Rechtsverletzungen werden wir derartige Inhalte umgehend
                entfernen.
              </p>
            </div>
            <br />
            <div className="padding-block-700">
              <h3 className="fw-bold">Lizenzierte Bilder</h3>
              <p>© Julia / #407422065 – stock.adobe.com.</p>
              <p>© antto / #241087241 – stock.adobe.com.</p>
              <p>© liana2012 / #512397869 – stock.adobe.com.</p>
              <p>© Chira.Stock / #691040334 – stock.adobe.com.</p>
              <p>© lovaisme / #468762534 – stock.adobe.com.</p>
              <p>© yisar / #628105676 – stock.adobe.com.</p>
              <p>© Nadiia / #890701328 – stock.adobe.com.</p>
              <p>© MKInayem / #798543376 – stock.adobe.com.</p>
              <p>© Photographee.eu / #199949296 – stock.adobe.com.</p>
              <p>© contrastwerkstatt / #126566030 – stock.adobe.com.</p>
              <p>© nenetus / #220140088 – stock.adobe.com.</p>
              <p>© Photographee.eu / #242094716 – stock.adobe.com.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
